import axios from 'axios'
import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import ScratchCard from 'react-scratchcard-v4'
import styled from 'styled-components'
import ScratchImage from '../../assets/img/praia/scratch-to-win-custom.png'
import config from '../../config/request.config'
import { ScratchContent, Scratchpad } from './styled'

const settings = {
  width: 516,
  height: 672,
  image: ScratchImage,
  finishPercent: 60,
};

interface ScratchProps {
  winner: boolean;
  number: number;
  concluded: boolean;
  countprizes: number;
  imageId: number;
}

const WinnerContent = styled.div<{ background: string }>`
  width: 100%;
  height: 100%;
  border: 2px solid var(--text-color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.background});
  background-size: cover;
  flex-direction: column; /* Para empilhar o conteúdo */
`;

const TryAgainContent = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid var(--text-color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${require('../../assets/abf/tryagain.jpg')});
  background-size: cover;
`;

const ConcludedContent = styled.div`
  width: 100%;
  height: 100%;
  border: 2px solid var(--text-color-light);
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${require('../../assets/abf/concluded.jpg')});
  background-size: cover;
`;

const Scratch: React.FC<ScratchProps> = ({ winner, number, concluded, countprizes, imageId }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null);

  // Define dinamicamente o caminho da imagem do prêmio
  const prizeImage = `/assets/img/prize/${imageId}.jpg`;

  // Função para buscar a URL do QRCode
  const fetchQRCodeUrl = async (id: number) => {
    try {
      const response = await axios.post(`${config.HOST}:${config.PORT}/v1/prizedraw/generate-qrcode`, { id });
      if (response.data.qrCodeUrl) {
        setQrCodeUrl(response.data.qrCodeUrl); // Salva a URL do QRCode no estado
      }
    } catch (error) {
      console.error('Erro ao gerar QRCode:', error);
    }
  };

  // Quando o prêmio for vencedor, chama a função para gerar o QRCode
  useEffect(() => {
    if (winner && imageId) {
      fetchQRCodeUrl(imageId);
    }
  }, [winner, imageId]);

  return (
    <ScratchContent>
      <Scratchpad>
        {concluded ? (
          <ScratchCard {...settings} key={imageId}>
            <ConcludedContent></ConcludedContent>
          </ScratchCard>
        ) : winner ? (
          <ScratchCard {...settings} key={imageId}>
            <WinnerContent background={prizeImage}>
              <p style={{ position: 'fixed', bottom: '738px', marginRight: '-340px', fontSize: '20px' }}>{number}</p>
              {qrCodeUrl ? (
                  <div style={{ width: '380px', height: '190px', backgroundColor: '#F0D8C0', marginTop: '180px', textAlign: 'center'  }}>
                  <QRCode value={qrCodeUrl} size={190} />
                </div>
              ) : (
                <p>Gerando QRCode...</p>
              )}
            </WinnerContent>
          </ScratchCard>
        ) : (
          <ScratchCard {...settings} key={imageId}>
            <TryAgainContent></TryAgainContent>
          </ScratchCard>
        )}
      </Scratchpad>
    </ScratchContent>
  );
};

export default Scratch;
